class Print {
  printClasses = {
    base: "print-menu",
  };
  constructor($el) {
    this.$el = $el;
    this.modifier = this.$el.data("modifier");
    console.log(this);
    this.$el.on("click", this.clickHandler);
  }

  removeClasses = () => {
    window._$html.removeClass();
    // window._$html.removeClass(this.printClasses.base);
    // window._$html.removeClass(`${this.printClasses.base}--${this.modifier}`);
  };

  clickHandler = () => {
    this.removeClasses();
    window._$html.addClass(this.printClasses.base);
    window._$html.addClass(`${this.printClasses.base}--${this.modifier}`);

    window.print();
  };

  destroy = () => {
    this.$el.off("click", this.clickHandler);
    this.removeClasses();
  };
}

export default Print;
